import {
  CheckCircleOutlined,
  CopyOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { useState } from 'react'
import { Button } from 'antd'
import { BaseButtonProps } from 'antd/lib/button/button'

type CopyTextButtonProps = {
  id?: string
  textToCopy: string
  showIcon?: boolean
  onCopyClick?: VoidFunction
  type?: BaseButtonProps['type']
}
/**
 * Displays a "Copy" button which, when pressed, copies the text specified in the
 * `textToCopy` property.  This component is a light refactor of `CopyTextComponent`,
 * and retains most of the API for compatibility's sake.
 */
export function CopyTextButton(props: CopyTextButtonProps) {
  const [state, setState] = useState<'Not Copied' | 'Copied' | 'Error'>(
    'Not Copied',
  )
  const onClick = () => {
    navigator.clipboard
      .writeText(props.textToCopy)
      .then(() => setState('Copied'))
      .catch(() => setState('Error'))
  }
  return (
    <Button
      id={props.id}
      onClick={onClick}
      type={props.type}
      icon={
        state === 'Not Copied' ? (
          <CopyOutlined />
        ) : state === 'Copied' ? (
          <CheckCircleOutlined />
        ) : (
          <WarningOutlined />
        )
      }
    >
      {state === 'Not Copied'
        ? 'Copy'
        : state === 'Copied'
          ? 'Copied'
          : 'Error Copying'}
    </Button>
  )
}
